import { ResponseDto, ErrorResponseDto } from 'theSource/types';
import { useApiMutation } from 'theSource/utils';
import { PUT_ENROLLMENT_STATUS_QUERY_KEY } from '.';

interface EnrollmentStatusQueryProps {
  lumosApiHost: string;
}

interface EnrollmentStatusRequestDto {
  status: string;
  enrollment_type: string;
}

export const useEnrollmentStatusQuery = ({
  lumosApiHost,
}: EnrollmentStatusQueryProps) => {
  const { isLoading, mutate: EnrollmentStatusRequest } = useApiMutation<
    ResponseDto,
    ErrorResponseDto,
    EnrollmentStatusRequestDto
  >({
    queryKey: PUT_ENROLLMENT_STATUS_QUERY_KEY,
    method: 'put',
    endpoint: `${lumosApiHost}/v2/self_service/enrollments/status`,
    getErrorMessage: (error) => error.response?.data?.details,
    showSuccessSnackbar: false,
  });

  return {
    isLoading,
    EnrollmentStatusRequest,
  };
};
